export const reelActionButtonTypeOptions = [
    {value: "1", label: "Własny URL"},
    {value: "2", label: "Formularz zapytania"},
];
